<template>
  <div>
    <el-card class="page-container">
      <h1 class="title-biaoti">主播引入用户明细</h1>
      <el-row>
        <DatePicker @datePickedChange="datePickedChange"></DatePicker>
        <el-input
          v-model="rid"
          placeholder="主播rid、用户rid"
          style="margin: 0 10px; width: 200px"
        ></el-input>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="downloadReport">下载</el-button>
      </el-row>
      <el-row>
        <div v-loading="loading">
          <CustomTable1
            :tableList="tableData"
            :options="tableOptions"
            class="table"
            :pageSize="30"
            :total="pageInfo.total"
            :currentPage="pageInfo.currentPage"
            @handleCurrentChange="handleCurrentChange"
          ></CustomTable1>
        </div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import CustomTable1 from '@/components/CustomTable1'
import DatePicker from '@/components/DatePicker'
export default {
  data() {
    return {
      //加载
      loading: false,
      tableData: [],
      rid: '',
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      pageInfo: {
        total: 0,
        currentPage: 1
      },
      tableOptions: {
        theader: [
          {
            name: 'registerDate',
            label: '注册日期'
          },
          {
            name: 'actorRid',
            label: '用户ID'
          },
          {
            name: 'actorCountry',
            label: '用户国家'
          },
          {
            name: 'actorLang',
            label: '用户语言'
          },
          {
            name: 'introducerRid',
            label: '引入者ID'
          },
          {
            name: 'agentName',
            label: '代理名称'
          },
          {
            name: 'introducerCountry',
            label: '引入者国家'
          },
          {
            name: 'introducerLang',
            label: '引入者语言'
          },
          {
            name: 'introduceType',
            label: '引入方式'
          },
          {
            name: 'lastActiveTime',
            label: '最近活跃时间'
          },
          {
            name: 'isPayOnRegistrationDay',
            label: '注册当日是否充值'
          },
          {
            name: 'topUpAmountOnRegistrationDay',
            label: '注册日充值金额-美元'
          },
          {
            name: 'totalPurchases',
            label: '总购买次数'
          },
          {
            name: 'totalPurchaseAmount',
            label: '总购买金额'
          },
          {
            name: 'lastPurchaseTime',
            label: '最后一次购买时间'
          },
          {
            name: 'lastPurchaseAmount',
            label: '最后一次购买金额'
          },
          {
            name: 'longestCallRid',
            label: '用户最长通话ID'
          },
          {
            name: 'longestTalkTime',
            label: '用户最长通话时长'
          },
          {
            name: 'numberOfBigGiftGoldCoins',
            label: '用户大礼物金币数'
          },
          {
            name: 'bigGiftRecipientRid',
            label: '用户大礼物收礼物者id'
          }
        ]
      }
    }
  },
  components: {
    CustomTable1,
    DatePicker
  },
  created() {
    this.getList()
  },
  methods: {
    // 查询列表
    async getList() {
      this.loading = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.introduce_users,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          rid: this.rid,
          page: this.pageInfo.currentPage
        }
      })
      this.loading = false
      if (res.code != 0) return this.$message(res.msg)
      this.tableData = res.data.data
      this.pageInfo.total = res.data.total
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getList()
    },
    datePickedChange(date) {
      this.datePicked = date
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.download_introduce_users +
        '?token=' +
        this.$store.getters.token +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&rid=' +
        this.rid +
        '&page=' +
        this.pageInfo.currentPage +
        '&username=' +
        this.$store.getters.username
    }
  }
}
</script>
<style>
</style>
